// extracted by mini-css-extract-plugin
export default {"description":"ForthScreen_description__RUpwg","title":"ForthScreen_title__35pUX"};